import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import React from 'react'
import {DiscountRibbon} from '~/icons/home-page/discoun-ribbon-corner'
import type {RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'

interface DiscountCornerBadgeProps extends HTMLAttributes<HTMLDivElement> {
  discount: number
}

const DiscountCornerRibbon: FunctionComponent<DiscountCornerBadgeProps> = ({discount, ...attributes}) => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)

  return (
    <div {...attributes}>
      <div className="relative">
        <DiscountRibbon className="ribbon" text={translations.Badge.discountOff(discount)} />
      </div>
    </div>
  )
}

export default DiscountCornerRibbon
